import(/* webpackMode: "eager" */ "/home/ubuntu/download/6967319dc9f2cb0014709f4f/investpro_daily/src/app/live-performance-dashboard/page.tsx");
